document.addEventListener('DOMContentLoaded', () => {
  const collectionSliders = document.querySelectorAll('[data-collection-slider]')
  collectionSliders.forEach((el) => {
    new Swiper(el, {
      slidesPerView: 2.3,
      spaceBetween: 20,
      centerInsufficientSlides: true,
      preloadImages: false,
      watchSlidesProgress: true,
      mousewheel: true,
      lazy: {
        loadOnTransitionStart: true,
        loadPrevNextAmount: 5
      },
      a11y: true,
      breakpoints: {
        480: {
          spaceBetween: 25
        },
        640: {
          spaceBetween: 40,
          slidesPerView: 3.3,
        },
        1024: {
          spaceBetween: 50,
          slidesPerView: 4.3
        },
        1600: {
          spaceBetween: 60,
          slidesPerView: 5.3,
        }
      }
    });
  })
})
